// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tUB_","right":"styles_right__3T536"};